import { AnalysisMode, type OptionData } from '../types/index'

/**
 * Centralized Ranking Helper
 * Follows Rule: "Identify the rank based on OI (or Volume) highest to lowest within strike range"
 * Rank 1 = Highest Value
 */
export const getSortedOptions = (options: OptionData[], mode: AnalysisMode, type: 'CE' | 'PE'): OptionData[] => {
    return [...options].sort((a, b) => {
        const valA =
            type === 'CE'
                ? mode === AnalysisMode.OI
                    ? a.callOpenInterest
                    : a.callVolume
                : mode === AnalysisMode.OI
                  ? a.putOpenInterest
                  : a.putVolume
        const valB =
            type === 'CE'
                ? mode === AnalysisMode.OI
                    ? b.callOpenInterest
                    : b.callVolume
                : mode === AnalysisMode.OI
                  ? b.putOpenInterest
                  : b.putVolume
        return (valB || 0) - (valA || 0)
    })
}
